import React from 'react';
import { HeroAndUrgency } from './HeroAndUrgency';
import { PainAndAgitation } from './PainAndAgitation';
import { SolutionReveal } from './SolutionReveal';
import { OfferBreakdown } from './OfferBreakdown';
import { SocialProofAndUpsell } from './SocialProofAndUpsell';
import { TrustAndFAQ } from './TrustAndFAQ';
import { CloseAndFinalCTA } from './CloseAndFinalCTA';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-chocolate font-body text-textBody selection:bg-gold/30 selection:text-chocolate" data-id="element-205">
      {/*
                  The main container wraps everything to ensure it doesn't get too wide on massive screens,
                  but the individual sections handle their own background colors which bleed full width.
                  Actually, to let backgrounds bleed, we keep the sections full width and constrain their inner content.
                */}
      <div className="w-full overflow-x-hidden" data-id="element-206">
        <HeroAndUrgency data-id="element-207" />
        <PainAndAgitation data-id="element-208" />
        <SolutionReveal data-id="element-209" />
        <OfferBreakdown data-id="element-210" />
        <SocialProofAndUpsell data-id="element-211" />
        <TrustAndFAQ data-id="element-212" />
        <CloseAndFinalCTA data-id="element-213" />
      </div>
    </main>;
}